import React from 'react';
import { createRoot } from 'react-dom/client';
import Moment from 'react-moment';
import { BrowserRouter } from 'react-router-dom';
import App from 'components/app';
import { StoreProvider } from 'helpers/store';
import 'react-datepicker/dist/react-datepicker.css';
import 'moment/locale/ru';
import './scss/index.scss';

Moment.globalLocale = 'ru';
Moment.globalFormat = 'DD.MM.YYYY';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <StoreProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StoreProvider>,
);
